import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		sectionSummary_sectionContainer: {
			padding: theme.spacing(3, 0),
		},
		sectionSummary_sectionDivider: {
			backgroundColor: theme.palette.grey[400],
		},
		sectionSummary_sectionLabelContainer: {
			display: 'flex',
		},
		sectionSummary_sectionLabel: {
			fontSize: theme.typography.h5.fontSize,
			color: theme.palette.info.main,
			fontWeight: theme.typography.fontWeightBold,
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		sectionSummary_sectionLabelIconContainer: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			marginRight: theme.spacing(2),
		},
		sectionSummary_sectionLabelIcon: {
			fontSize: theme.typography.h4.fontSize,
			color: theme.palette.info.main,
		},
		sectionSummary_sectionStatusLabelContainer: {
			marginTop: theme.spacing(1),
			display: 'flex',
		},
		sectionSummary_sectionStatusLabelContainerComplete: {
			color: theme.palette.success.main,
		},
		sectionSummary_sectionStatusLabelContainerIncomplete: {
			color: theme.palette.error.main,
		},
		sectionSummary_sectionStatusLabelContainerInfo: {
			color: theme.palette.error.main,
		},
		sectionSummary_sectionStatusIconContainer: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		sectionSummary_sectionStatusIcon: {
			marginRight: theme.spacing(.5),
			fontSize: theme.typography.h6.fontSize,
		},
		sectionSummary_sectionStatusLabel: {
			fontSize: theme.typography.subtitle1.fontSize,
			fontStyle: 'italic',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		sectionSummary_sectionBody: {
			padding: theme.spacing(2, 0),
		},
		sectionSummary_sectionBodyEmpty: {
			padding: theme.spacing(1, 0),
		},
		sectionSummary_sectionButtonContainer: {
			marginTop: theme.spacing(1),
		},
	});
});

export default useStyles;
